// extracted by mini-css-extract-plugin
export default {"affiliation":"CardAffiliation_affiliation__WCjAH","org-link":"CardAffiliation_org-link__jFx1P"};